const BASE_URL = `ipc_web/`;
const TIME_OUT = 10000;
const DEFAULT_SIGN_URL = ["redirect", "user/login"];
export { BASE_URL, TIME_OUT, DEFAULT_SIGN_URL };
